import { Check } from "@mui/icons-material";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { useCallback } from "react";

export default function PillFilter({
  title,
  filters,
  currentFilter,
  handleChange,
  required = false,
  keyPrefix = "",
  disabled = false,
  sx,
  ...otherProps
}) {
  const isSelected = useCallback(
    (key) => {
      return key === currentFilter;
    },
    [currentFilter]
  );

  function handleSelect(key) {
    if (key !== currentFilter) {
      handleChange(key);
    } else if (!required) {
      handleChange(null);
    }
  }
  return (
    <Stack
      direction="column"
      sx={{
        p: 2,
        ...sx,
      }}
      {...otherProps}
    >
      <Typography variant="subtitle2">{title}</Typography>
      <Stack
        direction="row"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
        sx={{
          "&:after": {
            content: '""',
            flex: "auto",
          },
        }}
      >
        {filters.map((item) => {
          const chip = (
            <Chip
              key={`${keyPrefix}-${item.key}`}
              label={item.label}
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!item.disabled) {
                  handleSelect(item.key);
                }
              }}
              icon={isSelected(item.key) ? <Check /> : null}
              variant={isSelected(item.key) ? "filter" : "outlined"}
              disabled={disabled || item.disabled}
            />
          );
          return item.disabled && item.disabledReason ? (
            <Tooltip
              key={`${keyPrefix}-${item.key}-tooltip`}
              title={item.disabledReason}
            >
              <span>{chip}</span>
            </Tooltip>
          ) : (
            chip
          );
        })}
      </Stack>
    </Stack>
  );
}
